module.exports = __webpack_public_path__ + "static/media/menu.74bc27b6.svg";